import { z } from 'zod';

// ═══════════════════════════════════════════════════════════════
// ONBOARDING PERSONA MORAL (PM) — Aviso de privacidad (GAP 5a, contrato #412)
// Bloque `closing`, step `privacy_notice_acceptance`, ANTES de la firma de
// contratos. Validador BE `consent_explicit` (web_checkbox), error ONB_PRIVACY_001.
//
// Una sola casilla de aceptación; al enviarla el form llama al endpoint
// compartido `consent` con truthful_declaration + data_sharing_consent = true.
// ═══════════════════════════════════════════════════════════════

export const privacyNoticeSchema = z.object({
  /** Casilla "He leído y acepto el Aviso de Privacidad" — debe ser true. */
  accepted: z.literal(true, {
    errorMap: () => ({ message: 'Debes aceptar el Aviso de Privacidad para continuar' }),
  }),
});

export type PrivacyNoticeFormData = z.infer<typeof privacyNoticeSchema>;
